require('angular').module('wowApp.common')
    .service('SavedListsService', ['Restangular', '$rootScope', '$q', 'BootstrapService', 'RRPubSub', 'CurrentUserService', 'DecorateAdditionalDetails', require('./saved-lists-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/savedlists/index.js
 **/